<template>
  <div class="login-page-container" id="banner">
    <div class="login-form-container" v-if="gameList.length > 0">
      <jt-login-form
        class="login-form"
        :gameList="gameList"
        :loginloading="loginloading"
        :isButtonList="isButtonList"
        :isButtonNotBg="isButtonNotBg"
        :weihu="weihu"
        :ewm="ewm"
        :curindex="curindex"
        @login="userLogin"
        @resetindex="resetindex"
        :style="{ backgroundColor: bgcolor }"
      ></jt-login-form>
    </div>
    <div class="noMsg" v-else>{{ noGameMsg }}</div>
  </div>
</template>

<script>
import jtLoginForm from './jtLoginForm'
import GameModel from '../../models/game'
import UserModel from '../../models/user'
import config from '@/config'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'

export default {
  name: 'Login',
  components: {
    jtLoginForm,
  },
  data() {
    return {
      gameList: null,
      domainName: '',
      loginloading: false,
      isButtonList: false,
      isButtonNotBg: false,
      curindex: -1,
      ewm: '',
      bgcolor: 'rgba(255,255,255)',
      noGameMsg: '',
    }
  },
  methods: {
    async userLogin(userInfo) {
      if (!this.loginloading) {
        this.loginloading = true
        try {
          let { password } = userInfo
          userInfo.that = this
          const loginInfo = await UserModel.login(userInfo)
          const router = this.$router
          const logo = storage.getItem(constants.LOGO)
          const languageConfig = storage.getItem(constants.LANGUAGE)
          const ico = storage.getItem(constants.ICO)
          const title = storage.getItem(constants.TITLE)
          const oid = storage.getItem('oid')
          const cozeId = storage.getItem('COZEID')
          storage.clear()
          storage.setItem(constants.GLOBAL_CONFIG, loginInfo)
          storage.setItem(constants.LOGO, logo)
          storage.setItem(constants.LANGUAGE, languageConfig)
          storage.setItem(constants.ICO, ico)
          storage.setItem(constants.TITLE, title)
          storage.setItem('oid', oid)
          storage.setItem('COZEID', cozeId)
          if (password == config.orginPassword) {
            let msg = this.$t('jtLoginForm.CHANGE_PASSWORD_TIPS')
            let title = this.$t('global.TIPS')
            let ok = this.$t('header.BTN_UPDATEPASSWORD')
            this.$alert(msg, title, {
              confirmButtonText: ok,
              callback: (action) => {
                storage.setItem('orginPassword', 1)
                router.replace(`/updatepassword.html`)
              },
            })
          } else {
            router.replace(`/page/${loginInfo.pageInfo[0].pageId}`)
          }
        } catch (error) {
        } finally {
          this.loginloading = false
          this.curindex = -1
        }
      }
    },

    resetindex() {
      this.curindex = -1
    },
  },
  async mounted() {
    const router = this.$router
    const { gameId, token } = router.history.current.query
    let obj = await GameModel.getGameList(true, token)
    this.gameList = obj.gamelist
    this.isButtonList = obj.isButtonList
    this.isButtonNotBg = obj.isButtonNotBg
    this.bgcolor = obj.bgcolor
    this.weihu = obj.weihu
    this.ewm = obj.ewm
    this.noGameMsg = obj.noGameMsg
    this.$root.DOMAINNAME = obj.domainName
    this.$root.VISIBLE = obj.visible
    this.$root.HEADLOGO = obj.headlogo
    storage.setItem('bannerUrl', obj.bannerUrl)

    this.$emit('isShowHeader')

    if (obj.bannerUrl) {
      if (document.getElementById('banner')) {
        document.getElementById('banner').classList.add('banner')
      }
    }

    let logo = obj.logo ? obj.logo : 1

    storage.setItem(constants.LOGO, logo)
    storage.setItem(constants.GAME_LIST, obj.gamelist)

    if (gameId) {
      _.map(obj.gamelist, (item, index) => {
        if (item.id === parseInt(gameId)) {
          this.curindex = index
          const language = item['语言']
          const lang = {
            中文: 'zh',
            英文: 'en',
            中英文: 'enAndzh',
          }
          this.$i18n.locale = lang[language]
          this.$i18n.fallbackLocale = lang[language]
        }
      })
    }
  },

  created() {
    const info = storage.getItem(constants.WX_INFO)
    if (info) {
      const router = this.$router
      router.push(`/wxlogin`)
    }
  },
}
</script>

<style lang="stylus" scoped>
.login-page-container {
  width: 100%;
  height: 100%;

  div.bread-crumb {
    padding: 1em;
  }

  .login-form-container {
    min-height: calc(100% - 32px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login-form {
    width: 50%;
    // background-color: #fff;
    border: 2px solid gray;
    border-radius: 6px;
  }
}

.banner {
  .login-form-container {
    min-height: calc(100% - 46px);
  }

  .login-form {
    // background-color: rgba(255, 255, 255, 0.5);
    border: none;
    color: #000;
  }
}

.noMsg {
  min-height: calc(100% - 32px);
  font-size: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .login-page-container {
    .login-form {
      width: 95%;
      margin: 5px 0;
    }
  }

  .banner {
    .login-form-container {
      min-height: calc(100% - 0px);
    }
  }
}
</style>
